<template>
  <div class="main-content-box">
    
    <div class="bg-white">
      <div class="task-list-top content-width-1300">
        <div class="line-one">
          <span class="line-label">学科</span>
          <div class="filter-list">
            <span
              :class="{
                'filter-item': true,
                'filter-item-select': item.subjectId === subjectId
              }"
              v-for="(item, index) in subjectList"
              :key="index"
              @click="_subjectChange(Object.assign(item, {index}))"
            >{{item.subjectName}}</span>
          </div>
        </div>
        <div class="line-one classify-line" id="classifyLine">
          <span class="line-label">班级小组</span>
          <div
            class
            v-if="classesAndGroupsList && classesAndGroupsList.length"
            :class="{
                'filter-list': true,
              }"
            >
            <span
              :class="{
                  'filter-item': true,
                  'filter-item-all': true,
                  'filter-item-select': classOrGroupItem ? classOrGroupItem.classOrGroupId == 0 : true
                }"
              @click="_classGroupChange({ classOrGroupId: 0, classOrGroupName: '全部' })"
            >全部</span>
            <div class="in-list" id="classifyInList">
              <span
                :class="{
                    'filter-item': true,
                    'filter-item-select': item.classOrGroupId === classOrGroupItem.classOrGroupId
                  }"
                  v-for="(item, index) in classesAndGroupsList1"
                  :key="index"
                  @click="_classGroupChange(Object.assign(item, {index}))"
                >{{item.classOrGroupName}}</span>
            </div>
            <span v-if="openLineShow" class="icon-more" @click.stop="_openLine"><span>更多</span><i class="iconfont iconxiangzuo" :class="openLine ? 'icon-rotate' : ''" :title="openLine ? '收起' : '展开'"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="task-list-content content-width-1300">
      <div class="task-list-box">
        <el-tabs class="task-active-tabs" v-model="queryStatusSelect" @tab-click="_activeClick">
          <el-tab-pane label="进行中" name="1">
            <div slot="label" class="active-slot">
              <el-badge
                v-if="queryStatusObj.ongoingCount"
                :value="queryStatusObj.ongoingCount"
                :max="99"
              ></el-badge>进行中
            </div>
          </el-tab-pane>
          <el-tab-pane label="未开始" name="2">
            <div slot="label" class="active-slot">
              <el-badge
                v-if="queryStatusObj.noStartedCount"
                :value="queryStatusObj.noStartedCount"
                :max="99"
              ></el-badge>未开始
            </div>
          </el-tab-pane>
          <el-tab-pane label="已过期" name="3">
            <div slot="label" class="active-slot">
              <el-badge
                v-if="queryStatusObj.activeThreeNum"
                :value="queryStatusObj.activeThreeNum"
                :max="99"
              ></el-badge>已过期
            </div>
          </el-tab-pane>
        </el-tabs>
        <el-table
          class="list-table list-table-task-list"
          v-if="!isTabChange"
          key="elTable1"
          :data="dataList"
          height="100% - 24px"
          :cell-style="cellStyle"
          :header-cell-style="headerStyle"
          :cell-class-name="cellClassName"
          :default-sort="tableDefaultSort"
          @sort-change="_tableSort"
          v-loading="listLoading"
          element-loading-text="数据正在跑步前进中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="grba(255, 255, 255, 0.5)"
          >
          <el-table-column prop="isExcellent" label width="26px">
            <template slot-scope="scope">
              <i v-if="scope.row.isExcellent" class="iconfont iconyouxiu" title="优秀"></i>
            </template>
          </el-table-column>
          <el-table-column prop="learningTitle" label="主题" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="learning-title" @click="_preview(scope.row)">{{scope.row.learningTitle}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="classOrGroupName" label="班级小组" show-overflow-tooltip></el-table-column>
          <el-table-column prop="subjectTitle" label="学科" :width="90"></el-table-column>
          <el-table-column prop="estimated" label="预计耗时" :width="100">
          </el-table-column>
          <el-table-column prop="difficulty" label="难易程度" :width="90">
            <template slot-scope="scope">
              <span>{{scope.row.difficulty === 1 ? '简单' : (scope.row.difficulty ===2 ? '适中' : '困难')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="startTime1"
            label="开始时间"
            sortable="custom"
            :sort-orders="['ascending', 'descending']"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="dueTime1"
            label="截止时间"
            sortable="custom"
            :sort-orders="['ascending', 'descending']"
            width="150"
          ></el-table-column>
          <!-- learningStatus 学习状态 0:未开始 1:学习中 2:已完成 -->
          <el-table-column prop="learningStatus" label="学习状态" :width="90">
            <template slot-scope="scope">
              <span
                :class="{
                  'learning-status-1': scope.row.learningStatus === 1,
                  'learning-status-2': scope.row.learningStatus === 2,
                  'learning-status-3': !scope.row.learningStatus,
                }"
              >{{scope.row.learningStatus === 1 ? '学习中' : (scope.row.learningStatus ===2 ? '已完成' : '未开始')}}</span>
            </template>
          </el-table-column>
          <!-- exerciseStatus 练习状态 0:未提交 1:练习中 2:已提交 -->
          <el-table-column prop="exerciseStatus" label="提交状态" :width="90">
            <template slot-scope="scope">
              <span
                :class="{
                  'submit-status-1': scope.row.exerciseId && scope.row.exerciseStatus !== 2 && scope.row.learningStatus === 2,
                  'submit-status-2': scope.row.exerciseId && scope.row.exerciseStatus === 2,
                }"
              >{{scope.row.exerciseId && scope.row.exerciseStatus ? (scope.row.exerciseStatus === 2 ? '已提交' : '未提交') : '-'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="operate"
            label="操作"
            :width="80"
            v-if="editPower"
            >
            <template slot-scope="scope">
              <div class="operate-scope">
                <i
                  class="iconfont iconchakan"
                  title="查看"
                  @click="_rowOperateClick(Object.assign(scope.row, {index: scope.$index}), 'detail')"
                ></i>
                <i
                  class="iconfont icondianping"
                  :class="{
                    'visibility-h': !scope.row.review
                  }"
                  title="查看点评"
                  @click="_rowOperateClick(Object.assign(scope.row, {index: scope.$index}), 'comment')"
                ></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="last-props" label width="26px">
          </el-table-column>
          <template slot="empty">
            <div class="el-table-slot-empty" v-if="!dataList.length && listLoading">
              <p></p>
            </div>
            <div class="el-table-slot-empty" v-else-if="!dataList.length && !listLoading">
              <img src="../../assets/task-empty.png" alt class="empty-img" />
              <p>暂无任务数据~</p>
            </div>
          </template>
        </el-table>
        <el-table
          class="list-table list-table-task-list"
          v-else
          key="elTable2"
          :data="[]"
          height="100% - 24px"
          :cell-style="cellStyle"
          :header-cell-style="headerStyle"
          :cell-class-name="cellClassName"
          :default-sort="tableDefaultSort"
          @sort-change="_tableSort"
          v-loading="listLoading"
          element-loading-text="数据正在跑步前进中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="grba(255, 255, 255, 0.5)"
          >
          <el-table-column prop="isExcellent" label width="26px">
            <template slot-scope="scope">
              <i v-if="scope.row.isExcellent" class="iconfont iconyouxiu" title="优秀"></i>
            </template>
          </el-table-column>
          <el-table-column prop="learningTitle" label="主题" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="learning-title" @click="_preview(scope.row)">{{scope.row.learningTitle}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="classOrGroupName" label="班级小组" show-overflow-tooltip></el-table-column>
          <el-table-column prop="subjectTitle" label="学科" :width="90"></el-table-column>
          <el-table-column prop="estimated" label="预计耗时" :width="100">
          </el-table-column>
          <el-table-column prop="difficulty" label="难易程度" :width="90">
            <template slot-scope="scope">
              <span>{{scope.row.difficulty === 1 ? '简单' : (scope.row.difficulty ===2 ? '适中' : '困难')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="startTime1"
            label="开始时间"
            sortable="custom"
            :sort-orders="['ascending', 'descending']"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="dueTime1"
            label="截止时间"
            sortable="custom"
            :sort-orders="['ascending', 'descending']"
            width="150"
          ></el-table-column>
          <!-- learningStatus 学习状态 0:未开始 1:学习中 2:已完成 -->
          <el-table-column prop="learningStatus" label="学习状态" :width="90">
            <template slot-scope="scope">
              <span
                :class="{
                  'learning-status-1': scope.row.learningStatus === 1,
                  'learning-status-2': scope.row.learningStatus === 2,
                  'learning-status-3': !scope.row.learningStatus,
                }"
              >{{scope.row.learningStatus === 1 ? '学习中' : (scope.row.learningStatus ===2 ? '已完成' : '未开始')}}</span>
            </template>
          </el-table-column>
          <!-- exerciseStatus 练习状态 0:未提交 1:练习中 2:已提交 -->
          <el-table-column prop="exerciseStatus" label="提交状态" :width="90">
            <template slot-scope="scope">
              <span
                :class="{
                  'submit-status-1': scope.row.exerciseId && scope.row.exerciseStatus !== 2 && scope.row.learningStatus === 2,
                  'submit-status-2': scope.row.exerciseId && scope.row.exerciseStatus === 2,
                }"
              >{{scope.row.exerciseId && scope.row.exerciseStatus ? (scope.row.exerciseStatus === 2 ? '已提交' : '未提交') : '-'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="operate"
            label="操作"
            :width="80"
            v-if="editPower"
            >
            <template slot-scope="scope">
              <div class="operate-scope">
                <i
                  class="iconfont iconchakan"
                  title="查看"
                  @click="_rowOperateClick(Object.assign(scope.row, {index: scope.$index}), 'detail')"
                ></i>
                <i
                  class="iconfont icondianping"
                  :class="{
                    'visibility-h': !scope.row.review
                  }"
                  title="查看点评"
                  @click="_rowOperateClick(Object.assign(scope.row, {index: scope.$index}), 'comment')"
                ></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="last-props" label width="26px">
          </el-table-column>
          <template slot="empty">
            <div class="el-table-slot-empty">
              <p></p>
            </div>
          </template>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          v-if="pageTotal && pageTotal > pageSize"
          class="main-content-box-page"
          layout="total, prev, pager, next"
          :current-page="pageNum"
          :total="pageTotal"
          :page-size="pageSize"
          @current-change="_pageNumChange"
        ></el-pagination>
        <div v-else class="main-content-box-page"></div>
      </div>
    </div>

    <!-- 组件：内容预览 -->
    <LearnTaskPreview
      v-if="operateDialogVisible"
      :dialog-visible="operateDialogVisible"
      :id="operateItem ? (operateItem.type === 'detail' ? operateItem.learningTaskId : operateItem.studentTaskId) : null"
      :preview-type="operateItem ? (operateItem.type === 'detail' ? 5 : 6) : null"
      :title="operateItem.learningTitle"
      @handleOk="_previewDialogOk"
    />
  </div>
</template>
<script>
import {
  localStorageUtil,
  sessionStorageUtil,
  debounce,
  formatDateTime,
  formatTimeDifference
} from "utils/util";
import { setOperatePower } from "utils/menuList";
import { reqGetClassesAndGroups, reqGetTaskList } from "api/my-task";
import LearnTaskPreview from "components/learn-task/learn-task-preview";
export default {
  components: {
    LearnTaskPreview
  },
  data() {
    return {
      preDis: true,
      nextDis: false,
      lastClickTime: null,
      noScroll: true, // 班级小组列表是否要滚动
      openLine: false,
      openLineShow: false,
      subjectId: 0,
      subjectList: [],
      classesAndGroupsList: [],
      classOrGroupItem: null,
      queryStatusSelect: "1",
      queryStatusObj: {
        ongoingCount: 0,
        noStartedCount: 0,
        activeThreeNum: 0
      },
      tableDefaultSort: { prop: "dueTime1", order: "ascending" },
      tableSort: { type: 'orderByDueTime', order: 1 },
      isTabChange: false,
      dataList: [],
      pageTotal: 0,
      pageSize: 9,
      pageWidth: document.querySelector("#app").clientWidth,
      pageNum: 1,
      cellStyle: function(row, column, rowIndex, columnIndex) {
        if (row.column.property === "operate") {
          return "color: #3A3A3A; text-align: center;";
        } else if (row.column.property === "modifiedTime") {
          return "color: #3A3A3A; padding-left: 40px";
        }
        return "color: #3A3A3A;";
      },
      headerStyle: function(row, column, rowIndex, columnIndex) {
        if (row.column.property === "operate") {
          return "color: #3A3A3A; font-weight: bold; font-size: 14px; text-align: center;";
        } else if(row.column.property === "learningTitle") {
          return "color: #3A3A3A; font-weight: bold; font-size: 14px; padding-left: 10px;";
        } else if (row.column.property === "modifiedTime") {
          return "color: #3A3A3A; font-weight: bold; font-size: 14px; padding-left: 40px;";
        } else if (row.column.property === "isExcellent") {
          return "border-bottom-color: transparent";
        } else if (row.column.property === "last-props") {
          return "border-bottom-color: transparent";
        }
        return "color: #3A3A3A; font-weight: bold; font-size: 14px;";
      },
      cellClassName: function({ row, column, rowIndex, columnIndex }) {
        if (column.property === "isExcellent") {
          return "excellent-column";
        }else if(column.property === "learningTitle") {
          return "learningTitle-column";
        }
      },
      listLoading: true,
      okLoading: false,
      operateItem: null,
      operateDialogVisible: false,
      dialogContent: "",
      editPower: true,
    };
  },
  filters: {
    chapterFilter(val) {
      let str = `${val.subjectName}/${val.editionName}/${val.volumeName}/${val.chapterOneTitle}`;
      if (val.chapterTwoTitle) {
        str += `/${val.chapterTwoTitle}`;
      } else if (val.chapterThreeTitle) {
        str += `/${val.chapterThreeTitle}`;
      }
      return str;
    }
  },
  computed: {
    classesAndGroupsList1() {
      if(this.classesAndGroupsList.length) {
        return [...this.classesAndGroupsList].splice(1, this.classesAndGroupsList.length - 1);
      }else {
        return [];
      }
    }
  },
  methods: {
    /**
     * 学科select
     * **/
    _subjectChange(item) {
      this.subjectId = item.subjectId;
      this.pageNum = 1;
      this._getTasklList();
    },
    /**
     * 班级小组select
     * **/
    _classGroupChange(item) {
      this.classOrGroupItem = item;
      this.pageNum = 1;
      this._getTasklList();
    },

    /**
     * tab切换
     * **/
    _activeClick(tab, event) {
      this.isTabChange = true;
      this.pageNum = 1;
      if(this.queryStatusSelect === '1') {
        this.tableDefaultSort = { prop: "dueTime1", order: "ascending" };
        this.tableSort = { type: 'orderByDueTime', order: 1 };
      }else if(this.queryStatusSelect === '2') {
        this.tableDefaultSort = { prop: "startTime1", order: "ascending" };
        this.tableSort = { type: 'orderByStartTime', order: 1 };
      }else if(this.queryStatusSelect === '3') {
        this.tableDefaultSort = { prop: "dueTime1", order: "descending" };
        this.tableSort = { type: "orderByDueTime", order: 2 };
      }
     
      this._getTasklList();
    },

    /**
     * 页数change
     * **/
    _pageNumChange(val) {
      this.pageNum = val;
      this._getTasklList('pageChange');
    },

    /**
     * 表格排序
     * **/
    _tableSort({ column, prop, order }) {
      if (prop === "startTime1" || prop === "startTime") {
        this.tableSort = {
          type: "orderByStartTime",
          order: order === "ascending" ? 1 : 2
        };
      } else if (prop === "dueTime1" || prop === "dueTime") {
        this.tableSort = {
          type: "orderByDueTime",
          order: order === "ascending" ? 1 : 2
        };
      }
      this.pageNum = 1;
      this._getTasklList();
    },

    /**
     * 获取学习小组列表
     * **/
    _getClassesAndGroups(params) {
      let obj = {
        queryType: 1
      };

      this.listLoading = true;
      reqGetClassesAndGroups(obj)
        .then(res => {
          if (res.code === 0 && res.data) {
            this._setSubjectList(res.data.subjectList);
            this._setClassesAndGroups(res.data.classOrGroupList);
            this._getTasklList(params);
          } else {
            if(res.code !== 0) {
              this.$message({
                type: "error",
                message: "目录获取失败",
                duration: 2000
              });
            }
            this.dataList = [];
            this.listLoading = false;
          }
          
          this.$nextTick(() => {
            let _allH = $('#classifyInList').height();
            if(_allH < 40) {
              this.openLineShow = false;
            }else {
              this.openLineShow = true;
            }
          });
        })
        .catch(err => {
          this.dataList = [];
          this.listLoading = false;
          console.log("获取学习列表失败", err);
        });
    },
    /**
     * 班级小组展开折叠
     * **/
    _openLine(type) {
      let _allH = $('#classifyInList').height();
      if(this.openLine || type === 'close') {
        this.openLine = false;
        $('#classifyLine').animate({
          height: 34
        });
        return;
      }else {
        $('#classifyLine').animate({
          height: _allH
        });
        
      }
      this.openLine = !this.openLine;
    },
    _setSubjectList(list) {
      this.subjectList = list;
      this.subjectList.unshift({
        subjectId: 0,
        subjectName: "全部"
      });
      let index = this.subjectList.findIndex(
        ele => ele.subjectId === this.subjectId
      );
      if (index === -1) {
        this.subjectId = this.subjectList[0].subjectId;
      } else {
        this.subjectId = this.subjectList[index].subjectId;
      }
    },
    _setClassesAndGroups(list) {
      this.classesAndGroupsList = list;
      if(!this.classesAndGroupsList.length || (this.classesAndGroupsList.length && this.classesAndGroupsList[0].classOrGroupId)) {
        this.classesAndGroupsList.unshift({
          classOrGroupId: 0,
          classOrGroupName: '全部',
          type: null
        });
      }
      if (this.classOrGroupItem) {
        let index = this.classesAndGroupsList.findIndex(
          ele =>
            ele.type === this.classOrGroupItem.type &&
            ele.classOrGroupId === this.classOrGroupItem.classOrGroupId
        );
        if (index === -1) {
          this.classOrGroupItem = this.classesAndGroupsList[0];
        }
      } else {
        this.classOrGroupItem = {
          classOrGroupId: 0,
          classOrGroupName: '全部',
          type: null
        };
      }
    },

    /**
     * 获取学习列表
     * **/
    _getTasklList(params) {
      let obj = {
        groupType: this.classOrGroupItem.type,
        queryStatus: this.queryStatusSelect,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      if (this.subjectId) {
        obj.subjectId = this.subjectId;
      }
      if (this.classOrGroupItem.classOrGroupId) {
        obj.classOrGroupId = this.classOrGroupItem.classOrGroupId;
      }
      if (this.tableSort && this.tableSort.type) {
        if (this.tableSort.type === "orderByStartTime") {
          obj.orderByStartTime = this.tableSort.order;
        }
        if (this.tableSort.type === "orderByDueTime") {
          obj.orderByDueTime = this.tableSort.order;
        }
      }

      this.listLoading = true;
      this.dataList = [];
      if(params !== 'pageChange') {
        this.pageTotal = 0;
      }
      reqGetTaskList(obj)
        .then(res => {
          this.listLoading = false;
          this.isTabChange = false;
          if (res.code === 0) {
            this.queryStatusObj = {
              ongoingCount: res.data.ongoingCount,
              noStartedCount: res.data.noStartedCount,
              activeThreeNum: 0
            };
            this.dataList = res.data.datas;
            for (let x of this.dataList) {
              // x.estimated = x.estimated ? formatTimeDifference(null, null, x.estimated * 60 * 1000) : "";
              x.estimated = x.estimated ? x.estimated + '分钟' : "";
              x.startTime1 = x.startTime
                ? formatDateTime(new Date(x.startTime), "yyyy-MM-dd HH:mm")
                : "-";
              x.dueTime1 = x.dueTime
                ? formatDateTime(new Date(x.dueTime), "yyyy-MM-dd HH:mm")
                : "-";
              x.completedCount = x.completedCount ? x.completedCount : 0;
              x.totalStudentCount = x.totalStudentCount
                ? x.totalStudentCount
                : 0;
            }
            this.pageTotal = res.data.totalCount;
          }else {
            this.dataList = [];
            this.pageTotal = 0;
            this.$message({
              type: "error",
              message: "数据获取失败",
              duration: 2000
            });
          }
          setTimeout(() => {
            if (sessionStorageUtil.getItem("task-page-filter")) {
              sessionStorageUtil.removeItem("task-page-filter");
            }
          }, 500);
        })
        .catch(err => {
          this.listLoading = false;
          this.isTabChange = false;
          this.dataList = [];
          this.pageTotal = 0;
          console.log("获取学习列表失败", err);
        });
    },

    /**
     * 查看详情 修改期限 取消分配
     * **/
    _rowOperateClick(item, type) {
      this.operateItem = item;
      this.operateItem.type = type;
      if (type === "comment") {
        setTimeout(() => {
          this.operateDialogVisible = true;
        }, 50);
      }
      if (type === "detail") {
        // 查看详情
        this.$router.push({
          path: "/my-task/detail",
          query: {
            id: item.learningTaskId,
            id1: item.studentTaskId
          }
        });
      }
    },

    /**
     * 操作弹框--确定
     * **/
    _operateDialogOk() {
      this.okLoading = true;
      if (this.operateItem.type === "date") {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            let obj = {
              learningTaskId: this.operateItem.learningTaskId,
              startTime: formatDateTime(
                new Date(this.infoObj.startTime),
                "yyyy-MM-dd HH:mm"
              ),
              dueTime: formatDateTime(
                new Date(this.infoObj.dueTime),
                "yyyy-MM-dd HH:mm"
              )
            };
            reqUpdateTaskAssignmentDate(obj)
              .then(res => {
                if (res.code === 0) {
                  this._getClassesAndGroups();
                  this.$message({
                    type: "success",
                    message: "分配时间修改成功",
                    duration: 2000
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: "分配时间修改失败",
                    duration: 2000
                  });
                }
                this._operateDialogClose();
              })
              .catch(err => {
                this._operateDialogClose();
                console.log("err", err);
              });
          } else {
            this.okLoading = false;
          }
        });
      } else if (this.operateItem.type === "cancel") {
        let obj = {
          learningTaskId: this.operateItem.learningTaskId
        };
        reqCancelTaskAssignment(obj)
          .then(res => {
            if (res.code === 0) {
              this._getTasklList();
              this.$message({
                type: "success",
                message: "已取消分配",
                duration: 2000
              });
            } else {
              this.$message({
                type: "error",
                message: "取消分配失败",
                duration: 2000
              });
            }
            this._operateDialogClose();
          })
          .catch(err => {
            this._operateDialogClose();
            console.log("err", err);
          });
      }
    },

    /**
     * 操作弹框--取消
     * **/
    _operateDialogClose() {
      this.operateDialogVisible = false;
      this.okLoading = false;
      this.operateItem = null;
    },

    /**
     * 预览
     * **/
    _preview(item) {
      this.operateItem = item;
      this.operateItem.type = "detail";
      setTimeout(() => {
        this.operateDialogVisible = true;
      }, 50);
    },

    /**
     * 预览--确定
     * **/
    _previewDialogOk(item) {
      this.operateDialogVisible = false;
    },

    /**
     * 条件过滤参数数据回显
     * **/
    _handleFilterData() {
      let obj = sessionStorageUtil.getItem("task-page-filter");
      if (obj) {
        if (obj.subjectId) {
          this.subjectId = obj.subjectId;
        }
        if (obj.groupType) {
          this.classOrGroupItem = {
            type: obj.groupType,
            classOrGroupId: obj.classOrGroupId
          };
        } else {
          this.classOrGroupItem = null;
        }
        if (obj.queryStatus) {
          this.queryStatusSelect = obj.queryStatus;
        }
        if (obj.pageNum) {
          this.pageNum = parseInt(obj.pageNum);
        }
        if (obj.orderByStartTime) {
          this.tableSort = {
            type: "orderByStartTime",
            order: obj.orderByStartTime
          };
          this.tableDefaultSort = {
            prop: "startTime1",
            order: obj.orderByStartTime === 1 ? "ascending" : "descending"
          };
        }
        if (obj.orderByDueTime) {
          this.tableSort = {
            type: "orderByDueTime",
            order: obj.orderByDueTime
          };
          this.tableDefaultSort = {
            prop: "dueTime1",
            order: obj.orderByDueTime === 1 ? "ascending" : "descending"
          };
        }
      }
      this.$nextTick(() => {
        this._getClassesAndGroups("init");
      });
    },

  },
  mounted() {
  },
  created() {
    if(!localStorageUtil.getItem('isLogin')) {
      setTimeout(() => {
        this.$router.push('/home-page');
      }, 2);
      return;
    }
    this._handleFilterData();
  },
  destroyed() {
  },

  /**
   * 进入前进行权限的判断
   * **/
  beforeRouteEnter(to, from, next) {
    next(vm => {
      let power = setOperatePower("module", to);
      vm.editPower = power.editPower;
    });
  },

  beforeRouteLeave(to, from, next) {
    if (to.name !== "MyTaskDetail") {
      return next();
    }
    let obj = {
      queryStatus: this.queryStatusSelect,
      pageNum: this.pageNum
    };
    if (this.subjectId) {
      obj.subjectId = this.subjectId;
    }
    if (this.classOrGroupItem && this.classOrGroupItem.type) {
      obj.groupType = this.classOrGroupItem.type;
      obj.classOrGroupId = this.classOrGroupItem.classOrGroupId;
    }
    if (this.tableSort && this.tableSort.type) {
      if (this.tableSort.type === "orderByStartTime") {
        obj.orderByStartTime = this.tableSort.order;
      }
      if (this.tableSort.type === "orderByDueTime") {
        obj.orderByDueTime = this.tableSort.order;
      }
      this.tableDefaultSort = { 
        prop: this.tableSort.type === "orderByStartTime" ? "startTime1" : "dueTime1", 
        order: this.tableSort.order === 1 ? "ascending" : "descending"
      }
    }

    if (Object.keys(obj).length) {
      sessionStorageUtil.setItem("task-page-filter", obj);
    } else if (sessionStorageUtil.getItem("task-page-filter")) {
      sessionStorageUtil.removeItem("task-page-filter");
    }

    next();
  }
};
</script>
<style lang="less">
@color-main: #03B2B2;
.main-content-box {
  width: 100%;
  height: 100%;
  position: relative;
  .task-list-top {
    width: 100%;
    // height: 130px;
    padding: 30px 0px 26px 20px;
    margin-bottom: 20px;
    .line-one {
      display: inline-block;
      height: 34px;
      line-height: 34px;
      width: 100%;
      overflow: hidden;
      position: relative;
      & + .line-one {
        margin-top: 2px;
      }

      &:after {
        content: "";
        display: inline-block;
        width: 3px;
        height: 15px;
        background: @color-main;
        border-radius: 16px;
        position: absolute;
        top: 9px;
        left: 0;
      }

      .line-label {
        width: 90px;
        text-align: justify;
        font-size: 20px;
        font-weight: bold;
        display: inline-block;
        height: 34px;
        line-height: 34px;
        font-size: 16px;
        color: #999999;
        padding-left: 10px;
        &:after {
          content: "";
          display: inline-block;
          width: 100%;
        }
      }
      .filter-list {
        display: inline-block;
        width: calc(100% - 110px);
        vertical-align: top;
        line-height: 28px;
        padding-left: 30px;
        margin-top: 2px;
        .filter-item {
          display: inline-block;
          font-size: 14px;
          padding: 0px 16px;
          border-radius: 4px;
          color: #444444;
          cursor: pointer;
          &:not(:last-of-type) {
            margin-right: 4px;
          }
          &.filter-item-select {
            color: #fff;
            background: @color-main;
            // font-weight: bold;
          }
          &:not(.filter-item-select):hover {
            color: @color-main;
          }
        }
      }

    }
    
    .classify-line {
      min-width: 34px;
      .filter-list {
        display: inline-block;
        width: calc(100% - 110px);
        height: 100%;
        // padding-left: 10px;
        vertical-align: top;
        position: relative;
        .filter-item-all {
          display: inline-block;
          vertical-align: top;
          margin-right: 4px;
        }
        .in-list {
          display: inline-block;
          width: calc(100% - 30px - 60px);
          // height: 100%;
          .filter-item {
            margin-bottom: 10px;
          }
          
        }
        .icon-more {
          position: absolute;
          top: 0;
          right: -6px;
          color: #B3B3B3;
          cursor: pointer;
          height: 16px;
          line-height: 16px;
          margin-top: 6px;
          &:hover {
            color: @color-main;
          }
          span {
            display: inline-block;
            line-height: 16px;
            margin-right: 4px;
          }
          .iconxiangzuo {
            display: inline-block;
            line-height: 14px;
            height: 14px;
            vertical-align: top;
            margin-left: 2px;
            transform: rotate(-90deg);
            transition: transform .3s;
            font-size: 12px;
            &.icon-rotate {
              transform: rotate(-270deg);
            }
          }
        }
      }
    }
  }
  .task-list-content {
    width: 100%;
    position: relative;
    .task-list-box {
      width: 100%;
      padding: 12px 24px 20px;
      // padding-top: 20px;
      // padding-bottom: 14px;
      // margin-top: 20px;
      // margin-bottom: 10px;
      border-radius:6px;
      // border:1px solid @color-main;
      border:1px solid @color-main;
      background: #fff;
      overflow: hidden;
      .task-active-tabs.el-tabs.el-tabs--top {
        padding: 0 26px;
        .el-tabs__header {
          margin-bottom: 8px;
          .el-tabs__nav-wrap {
            &:after {
              height: 1px;
              background: transparent;
            }

            .el-tabs__nav-scroll {
              .el-tabs__nav {
                margin-left: 40px;
                .el-tabs__active-bar {
                  height: 3px;
                  background-color: @color-main;
                  // bottom: 1px;
                }

                .el-tabs__item {
                  cursor: pointer;
                  font-size: 14px;
                  color: #888888;
                  height: 36px;
                  line-height: 36px;
                  &+.el-tabs__item {
                    padding-left: 40px;
                  }

                  .active-slot {
                    font-size: 14px;
                    color: #888888;
                    padding: 0 10px;
                    position: relative;
                  }

                  .el-badge {
                    height: 26px;
                    padding-right: 6px;
                    position: absolute;
                    right: 52px;
                    top:  6px;

                    .el-badge__content {
                      font-size: 12px;
                      background-color: #ff3131;
                      height: 18px;
                      line-height: 18px;
                      padding: 0 8px;
                    }
                  }

                  &.is-active {
                    .active-slot {
                      color: @color-main;
                      // font-weight: bold;
                    }

                    color: @color-main;
                  }

                  &:hover {
                    .active-slot {
                      color: @color-main;
                    }

                    color: @color-main;
                  }
                }
              }
            }
          }
        }
      }
      .list-table {
        &:before {
          height: 0;
        }
        th {
          padding-top: 14px;
          padding-bottom: 10px;
          // padding: 16px 12px;
          // &:nth-of-type(2) {
          //   .cell {
          //     padding-left: 6px;
          //   }
          // }
        }
        .el-table__header-wrapper {
        }
        &.el-table--enable-row-hover .el-table__body tr:hover > td {
          background: #DFFBFB;
        }
        th.is-leaf {
          // border-bottom: 2px solid #CECECE !important;
          // background-color: #E7E7E7;
          background:#FCF8E2;
          
        }
        td, th.is-leaf {
          border-bottom: 1px solid transparent !important;
        }
        .learning-title {
          cursor: pointer;
          color: @color-main;
          &:hover {
            color: @color-main;
          }
        }

        .learning-status-1 {
          color: #2c98ff;
        }
        .learning-status-2 {
          color: #219f85;
        }
        .learning-status-3 {
          color: #fe5656;
        }
        .submit-status-1 {
          color: #fe5656;
        }
        .submit-status-2 {
          color: #219f85;
        }

        .operate-scope {
          height: 25px;
          .iconfont {
            cursor: pointer;
            color: #60acff;
            padding: 0 10px;
            &.icondianping {
              color: #4bd0b5;
            }
          }
        }
       
        .el-table-slot-empty {
          padding-top: 60px;
          p {
            height: 40px;
            line-height: 40px;
            color: #999;
          }
        }
      }
      .list-table-task-list {
        min-height: 499px;
        .excellent-column {
          position: relative;
          .cell {
            position: absolute;
            right: -10px;
            top: 14px;
            padding: 0;
            text-align: right;
            z-index: 10;
            .iconfont {
              vertical-align: middle;
              color: #ffb607;
              display: inline-block;
              &:hover {
                opacity: 1;
              }
            }
            .iconshanchu1,
            .iconjinyong2 {
              color: #ee4217;
            }
          }
        }
        .learningTitle-column {
          .cell {
            padding-left: 20px;
          }
          
        }
        .el-loading-mask {
          .el-loading-spinner {
            margin-top: 0;
          }
        }
      }
      .main-content-box-page {
        height: 46px;
        text-align: center;
        padding-top: 20px;
      }
    }
  }
}
</style>